var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{class:_vm.componentClass},[_c('HeaderV2ControlMolecule'),_c('HeaderV2UserMolecule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }